import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import countryCode from 'src/assets/user/countrycode/cc.json';
import countryData from 'src/assets/user/countrycode/data.json';
@Component({
  selector: 'app-billing-address',
  templateUrl: './billing-address.component.html',
  styleUrls: ['./billing-address.component.scss'],
})
export class BillingAddressComponent {
  address: any[] = [];
  public cc = countryCode;
  public countryData = countryData;
  public selectedDialCode = '+91';
  public selectedCode = '';
  countrySelected;
  public billingAddressForm: FormGroup;
  public useProfileAddress = false;
  public guestAddress: any = {};
  constructor(
    public dialogRef: MatDialogRef<BillingAddressComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { address: any[]; useProfileAddress: boolean },
    public formBuilder: FormBuilder
  ) {}

  ngOnInit(): void {
    this.address = this.data.address;
    console.log(this.address);
    console.log(this.data.useProfileAddress);

    this.useProfileAddress = this.data.useProfileAddress;
    this.initBillingAddressForm();

    if (this.useProfileAddress && this.address) {
      this.setFormValues(this.address);
    }
  }
  countrySelectedd(index) {
    const addressDetails = this.billingAddressForm.get('Country')?.value;

    if (addressDetails == this.cc[index].name) {
      // this.selectedDialCode = this.cc[index].dial_code;
      this.countrySelected = this.cc[index].name;
    }
  }
  setFormValues(address: any): void {
    this.billingAddressForm.patchValue({
      Country: address.Country,
      State: address.State,
      City: address.City,
      ZipCode: address.ZipCode,
      AddressLine1: address.AddressLine1,
      AddressLine2: address.AddressLine2,
      CompanyName: address.CompanyName,
    });
    const country = address.Country || '';
    const countryData = countryCode.find((data) => data.name === country);
    if (countryData) {
      this.countrySelected = countryData.name;

      this.billingAddressForm.get('Country')?.setValue(this.countrySelected);
    }
  }
  initBillingAddressForm(): void {
    this.billingAddressForm = this.formBuilder.group({
      Country: ['', Validators.required],
      State: ['', Validators.required],
      City: ['', Validators.required],
      ZipCode: [
        '',
        [Validators.required, Validators.pattern(/^[A-Za-z0-9\s-]{4,10}$/)],
      ],

      AddressLine1: ['', Validators.required],
      AddressLine2: [''],
      CompanyName: [''],
    });
  }
  onUseProfileAddressChange(event: MatCheckboxChange): void {
    this.useProfileAddress = event.checked;
    if (this.useProfileAddress && this.address.length > 0) {
      this.setFormValues(this.address[0]);
    } else {
      this.billingAddressForm.reset();
      this.billingAddressForm.enable();
    }
  }

  onUpdate(): void {
    if (this.billingAddressForm.invalid && !this.useProfileAddress) {
      return;
    }
    console.log(this.billingAddressForm.value);
    const result = {
      useProfileAddress: this.useProfileAddress,
      address: this.billingAddressForm.value,
    };

    this.dialogRef.close(result);
  }
}
